import { baseUtils } from '../../utils/baseUtils';
import VersionManagerCore from '../versionManager.js';
import { pgVersionManager } from '../proGalleryVersionManager';
var FullscreenVersionManager = /** @class */ (function () {
    function FullscreenVersionManager(proGallertVersionManager) {
        this.pgVersionManager = proGallertVersionManager || pgVersionManager;
    }
    FullscreenVersionManager.prototype.getVersionFullscreenVersion = function () {
        var version = this.pgVersionManager.getVersion('fullscreen');
        if (version === VersionManagerCore.Versions.min) {
            return baseUtils.isDemoMode() || baseUtils.isStoreGallery()
                ? 'V2'
                : version;
        }
        return version;
    };
    FullscreenVersionManager.prototype.useFullScreenWideSidebar = function () {
        return (this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min);
    };
    FullscreenVersionManager.prototype.useFullScreenMobilePadding = function () {
        return (this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min);
    };
    FullscreenVersionManager.prototype.useFullScreenMoreinfoButtonAlways = function () {
        return (this.getVersionFullscreenVersion() === VersionManagerCore.Versions.min);
    };
    FullscreenVersionManager.prototype.useFullscreenNewDesktopNavbar = function () {
        return (this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min);
    };
    FullscreenVersionManager.prototype.useFullscreenNewSidebar = function () {
        return (this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min);
    };
    FullscreenVersionManager.prototype.useFullscreenNewSlider = function () {
        return (this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min);
    };
    FullscreenVersionManager.prototype.useFullscreenNewMobileLayout = function () {
        return (this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min);
    };
    FullscreenVersionManager.prototype.useFullscreenSettingsNewVersion = function () {
        return (this.getVersionFullscreenVersion() !== VersionManagerCore.Versions.min);
    };
    FullscreenVersionManager.prototype.update = function (dateCreated) {
        return this.pgVersionManager.update(dateCreated);
    };
    return FullscreenVersionManager;
}());
export { FullscreenVersionManager };
export default new FullscreenVersionManager();
//# sourceMappingURL=fullscreen.js.map